import { useTranslation } from "react-i18next";
import SecondaryBtn from "./SecondaryBtn";
import { useSelector } from "react-redux";
import { url } from "../../../shared/utils/url";
import { useParams } from "react-router-dom";
import emptyAnimation from '../../../assets/images/loader/empty.json';
import Lottie from "lottie-react";

const EmptyComplaint = ({ title }: any) => {
    const { t } = useTranslation('common');
    const tenant: string = useSelector((state: any) => state.data.tenant);
    const params = useParams();

    const handleNavigate = () => {
        const protocol = window.location.protocol;
        const www = window.location.host?.includes("www.") ? true : false;
        const host = www ? window.location.host?.replace("www.", "") : window.location.host;
        let currentHost: any = !!tenant ? host?.replace(`${tenant}.`, "") : host;
        let newUrl: any = title === "grievance" ? (tenant === url?.subdomain?.grievance ? `${protocol}//${currentHost}` : `${protocol}//${url?.subdomain?.grievance}.${currentHost}`) : (tenant === url?.subdomain?.vigilance ? `${protocol}//${currentHost}` : `${protocol}//${url?.subdomain?.vigilance}.${currentHost}`);
        if (params?.lang) {
            window.location.href = `${newUrl}/${params?.lang}`;
        } else {
            window.location.href = newUrl;
        }
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-center pb-[50px] xlx:pb-[60px] mt-[-10px]">
            <Lottie
                animationData={emptyAnimation}
                loop={true}
                autoplay={true}
                className="w-full xlsm:w-[500px] h-[275px] xlsm:h-[350px] mb-[-50px]"
            />
            <h3 className="text-primaryText dark:text-white font-bold text-center mb-[4px]">{t("profile.empty_complaint_title")}</h3>
            <h6 className="max-w-[366px] text-blackDull dark:text-textBlackDull font-semibold text-center mb-[20px]">{title === "grievance" ? t("profile.empty_complaint_desc") : t("profile.empty_complaint_desc1")}</h6>
            <SecondaryBtn onClick={() => handleNavigate()} title={title === "grievance" ? t("profile.grievance_btn") : t("profile.vigilance_btn")} css="!rounded-[10px] px-[20px] font-extrabold uppercase !h-[35px]" />
        </div>
    );
};

export default EmptyComplaint;